import { render, staticRenderFns } from "./PageWhySMS.vue?vue&type=template&id=5dbe0f22&scoped=true&"
import script from "./PageWhySMS.vue?vue&type=script&lang=js&"
export * from "./PageWhySMS.vue?vue&type=script&lang=js&"
import style0 from "./PageWhySMS.vue?vue&type=style&index=0&id=5dbe0f22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbe0f22",
  null
  
)

export default component.exports